// Tamil (ta) user-guide translations. HR/legal and native-speaker review is required before release.
export const USER_GUIDE_TRANSLATIONS_TA = {
  'getting-started': {
    title: 'தொடங்குவது எப்படி',
    summary: 'போர்ட்டலைப் பயன்படுத்துவது, தொலைபேசியில் நிறுவுவது, உங்கள் கணக்கை நிர்வகிப்பது ஆகியவற்றை அறியுங்கள்.',
    blocks: [
      {
        text: 'நீங்கள் ஏற்கனவே உள்நுழைந்துவிட்டீர்கள் — கடினமான பகுதி முடிந்தது. முதன்முதலில் உள்நுழைந்தபோது, தனியுரிமைக் கொள்கையை (PDPA) ஏற்றுக்கொள்வதற்கும் உங்கள் சொந்த கடவுச்சொல்லை அமைப்பதற்கும் போர்ட்டல் வழிகாட்டியது. இனி தேவையானவற்றைக் கண்டுபிடிக்க இந்தப் பக்கம் உதவும்.',
      },
      {
        heading: 'போர்ட்டலில் தேவையானதைத் தேடுவது',
        items: [
          'மெனு (பக்கப்பட்டி): அம்சங்களின் பட்டியலைத் திறக்க, மொபைலில் மேல் இடதுபுறம் உள்ள ☰ மெனு குறியைத் தட்டவும். கணினியில் அது இடதுபுறம் எப்போதும் திறந்திருக்கும்.',
          'அறிவிப்புகள்: மேல் வலதுபுறம் உள்ள 🔔 மணி, ஒப்புதல்கள், நினைவூட்டல்கள் மற்றும் புதுப்பிப்புகளைக் காட்டும். சிவப்புப் புள்ளி இருந்தால், நீங்கள் கவனிக்க வேண்டியது உள்ளது.',
          'உங்கள் கணக்கு: கடவுச்சொல்லை மாற்ற, பொறுப்பை மாற்ற (நிர்வாகி/சொத்து அணுகல் இருந்தால்), அல்லது வெளியேற, மேல் வலதுபுறம் உள்ள உங்கள் பெயர்/படத்தைத் தட்டவும்.',
          'Quick Actions: கீழ் வலதுபுறம் மிதக்கும் வட்டப் பொத்தான், பொதுவான பணிகளை ஒரே தட்டலில் திறக்கும்.',
          'மொழி: இந்த வழிகாட்டியை உங்களுக்கு விருப்பமான மொழியில் படிக்க, மேலே உள்ள மொழித் தேர்வியைப் பயன்படுத்தவும் (மேலும் மொழிகள் விரைவில் வரும்).',
        ],
      },
      {
        heading: 'செயலியாக நிறுவுங்கள் (பரிந்துரைக்கப்படுகிறது)',
        items: [
          'இந்த போர்ட்டல் உங்கள் தொலைபேசியில் ஒரு செயலி (PWA) போல இயங்கும் — App Store தேவையில்லை.',
          'Android (Chrome): மெனு ⋮ → "Add to Home screen" / "Install app" என்பதைத் தட்டவும்.',
          'iPhone (Safari): Share குறி → "Add to Home Screen" என்பதைத் தட்டவும்.',
          'முழுத்திரையிலும் வேகமாகவும் பயன்படுத்த, முகப்புத் திரையிலிருந்து இதைத் திறக்கவும்.',
        ],
      },
      {
        text: 'கடவுச்சொல் மறந்துவிட்டதா? உள்நுழைவுத் திரையில் "Forgot password?" என்பதைத் தட்டி, உங்கள் பணி மின்னஞ்சலை உள்ளிடவும் — புதிய கடவுச்சொல் அமைப்பதற்கான இணைப்பு மின்னஞ்சலில் வரும்.',
      },
      {
        text: 'சமீபத்திய தகவலை ஏற்ற, எந்தப் பக்கத்திலும் திரையை கீழே இழுத்து புதுப்பிக்கலாம்.',
      },
    ],
  },

  dashboard: {
    title: 'உங்கள் Dashboard',
    summary: 'உங்கள் முகப்புத் திரை — முக்கியத் தகவல்களும் அதிகம் பயன்படுத்தும் செயல்களுக்கான ஒரே-தட்டல் இணைப்புகளும்.',
    routeLabel: 'Dashboard-க்குச் செல்லவும்',
    blocks: [
      {
        text: 'Dashboard உங்கள் முகப்புத் திரை. நீங்கள் உள்நுழையும்போது இது திறக்கும்; மேல் இடதுபுறம் உள்ள நிறுவன லோகோவைத் தட்டி எப்போது வேண்டுமானாலும் திரும்பலாம். இது விரைவான கண்ணோட்டத்தையும் குறுக்கு வழிகளையும் காட்டும் — தெரியும் அட்டைகள் உங்கள் பொறுப்பைப் பொறுத்தது.',
      },
      {
        heading: 'அனைவரும் காண்பவை',
        items: [
          'மேலே உங்கள் பெயருடன் ஒரு வரவேற்புச் செய்தி.',
          'Recent Leave Applications: உங்கள் சமீபத்திய கோரிக்கைகளும் அவற்றின் நிலையும் (Pending, Approved போன்றவை). விவரங்களுக்கு கண் குறியைத் தட்டவும்; அல்லது Leave Management திறக்க "View all" என்பதைத் தட்டவும்.',
          'Leave Balances: ஒவ்வொரு விடுப்பு வகைக்கும் கிடைக்கும் நாட்கள், பயன்படுத்திய நாட்கள் மற்றும் உங்கள் உரிமையைக் காட்டும் அட்டை. முழுப் பட்டியலுக்கு "View all" என்பதைத் தட்டவும்.',
        ],
      },
      {
        text: 'Quick Actions: Clock In/Out, Apply for Leave, Submit a Petty Cash Claim போன்றவற்றை ஒரே தட்டலில் திறக்க, எந்தத் திரையிலும் கீழ் வலதுபுறம் உள்ள மிதக்கும் வட்டப் பொத்தானைத் தட்டவும். பணியாளர்கள் மற்றும் இயக்குநர்களுக்கு டிஜிட்டல் பெயர் அட்டையைப் பகிர "My Name Card" வசதியும் இருக்கும்.',
      },
      {
        text: 'My Approvals: உங்கள் முடிவுக்காகக் காத்திருக்கும் விடுப்புக் கோரிக்கைகள் இந்த அட்டையில் தோன்றும்; Dashboard-இல் எண்ணிக்கைக் குறியும் காட்டப்படும். ஒப்புதல்/நிராகரிப்பு முறைக்கு "அறிக்கை அதிகாரிகளுக்கு: விடுப்பை அங்கீகரித்தல்" பகுதியைப் பார்க்கவும்.',
      },
      {
        heading: 'குழு எச்சரிக்கைகள் (Reporting Officers & HODs)',
        items: [
          'Team Alerts உங்கள் குழுவின் வருகைப் பதிவில் உள்ள விதிவிலக்குகளைக் காட்டும் — எடுத்துக்காட்டாக, Clock In செய்தும் Clock Out செய்யாத தொழிலாளர்.',
          'எச்சரிக்கையைத் தட்டி பரிசீலித்து சரிசெய்யவும் (எ.கா. தொழிலாளர் சார்பில் Clock Out நேரத்தை உறுதிசெய்யவும்).',
        ],
      },
      {
        text: 'Nightwork மற்றும் Worker Trade Transfer அட்டைகள் உங்களுக்கு பொருந்தும்போது இங்கே தோன்றும் — எடுத்துக்காட்டாக, செயலில் உள்ள இரவுப்பணி, Recovery day (ஓய்வு நாள்), அல்லது உங்கள் ஒப்புதலுக்காகக் காத்திருக்கும் trade-transfer பதிவு இருந்தால். திறக்க அட்டையில் "View All" என்பதைத் தட்டவும். (விவரங்களுக்கு Nightwork மற்றும் Worker Trade Transfer பகுதிகளைப் பார்க்கவும்.)',
      },
    ],
  },

  attendance: {
    title: 'Clock In & Clock Out',
    summary: 'ஒவ்வொரு நாளும் உங்கள் வேலை நேரத்தையும் பணித்தள இடத்தையும் பதிவு செய்யுங்கள்.',
    routeLabel: 'Attendance திறக்கவும்',
    blocks: [
      {
        text: 'பக்கப்பட்டியில் "Attendance — Clock In/Out & Time Tracking" என்பதைத் திறக்கவும். இந்தப் பக்கம் நேரடி சிங்கப்பூர் நேரத்தையும் அன்றைய உங்கள் செயல்பாட்டையும் காட்டும்.',
      },
      {
        heading: 'Clock In செய்வது எப்படி',
        items: [
          'பச்சை நிற "Clock In" பொத்தானைத் தட்டவும்.',
          'தொலைபேசி கேட்கும்போது location அனுமதியை வழங்கவும் — GPS மூலம் உங்கள் பணித்தளம் உறுதிசெய்யப்படும்.',
          '"Select Location" சாளரத்தில் உங்கள் project-ஐத் தேர்ந்தெடுக்கவும். அருகிலுள்ள (~300m-க்குள்) project-கள் "Nearby" தாவலில் வரும்; இல்லையெனில் "All Projects" அல்லது தேடல் பெட்டியைப் பயன்படுத்தவும்.',
          'Project-க்கு ஒன்றுக்கு மேற்பட்ட பணித்தளம் இருந்தால், "Select Work Site" சாளரத்தில் உங்கள் தளத்தைத் தேர்ந்தெடுக்கவும். (ஒரே தளம் இருந்தால் அது தானாகத் தேர்வாகும்.)',
          'இப்போது Clock In முடிந்தது — பொத்தான் சிவப்பாக ("Clock Out") மாறும்; தொடங்கிய நேரத்துடன் "Active since" தெரியும்.',
        ],
      },
      {
        heading: 'Clock Out செய்வது எப்படி',
        items: [
          'சிவப்பு நிற "Clock Out" பொத்தானைத் தட்டவும். புதிய GPS இருப்பிடம் தானாகப் பெறப்படும்.',
          'கேட்கப்பட்டால், இன்று செய்த பணியை விவரிக்கும் குறுகிய Work Description-ஐ (குறைந்தது 10 எழுத்துகள்) உள்ளிட்டு, "Submit & Clock Out" என்பதைத் தட்டவும்.',
          'தொழிலாளர்களிடம் overtime பற்றி கேட்கப்படலாம்: "Yes"/"No" எனப் பதிலளித்து, பணி முடித்த நேரத்தைத் தேர்ந்தெடுத்து உறுதிசெய்யவும். இதுவே OT கோர உதவும்.',
          '"Clocked out successfully" என்ற செய்தி தெரியும்.',
        ],
      },
      {
        heading: 'உங்கள் செயல்பாடும் சுருக்கமும்',
        items: [
          'செயல்பாட்டுப் பட்டியல்: ஒவ்வொரு Clock In/Clock Out பதிவும், அதன் நேர அளவு, பணித்தளம், project code மற்றும் நீங்கள் சேர்த்த குறிப்புகளும்.',
          'காலத் தேர்வு: funnel குறியைத் தட்டி Today, This Week, This Month, Last Month என மாற்றலாம் — செயல்பாட்டுப் பட்டியலும் Summary-யும் ஒன்றாகப் புதுப்பிக்கும்.',
          'Summary: தேர்ந்தெடுத்த காலத்தின் வேலை நாட்களையும் பணியாற்றிய மணிநேரங்களையும் காட்டும் (திட்டமிட்ட மதிய/இரவு உணவு இடைவேளைகள் கழிக்கப்படும்).',
          'இன்று Nightwork shift அல்லது Recovery day (வேலை தேவையில்லை) என்றால் அறிவிப்புப் பட்டை தெரிவிக்கும்.',
        ],
      },
      {
        text: 'உங்கள் overtime-ஐயும் இங்கே காணலாம் — MOM மாதாந்திர 72 மணி வரம்பில் எவ்வளவு கணக்காகிறது என்பதும் (நடப்பு மாதத்தில் "Live", அல்லது "Finalized") மற்றும் Summary-க்குக் கீழே மாதாந்திர overtime calendar-உம் இருக்கும்.',
      },
      {
        text: 'Clock In செய்ய location அவசியம். "Location permission denied" என்று வந்தால், browser/தொலைபேசி settings-ல் இந்தப் போர்ட்டலுக்கு location access-ஐ இயக்கி மீண்டும் முயலவும்.',
      },
    ],
  },

  'leave-apply': {
    title: 'விடுப்புக்கு விண்ணப்பித்தல்',
    summary: 'விடுப்புக்கு விண்ணப்பித்து, ஆவணங்களை இணைத்து, ஒப்புதல் நிலையைக் கண்காணியுங்கள்.',
    routeLabel: 'Leave திறக்கவும்',
    blocks: [
      {
        heading: 'விடுப்புக்கு விண்ணப்பிக்க',
        items: [
          'பக்கப்பட்டியில் "Leave Management" என்பதைத் திறக்கவும்.',
          'மேலே "Apply for Leave" என்பதைத் தட்டவும்; அல்லது குறிப்பிட்ட balance அட்டையில் "Apply" என்பதைத் தட்டவும்.',
          'பட்டியலில் உங்கள் விடுப்பு வகையைத் தேர்ந்தெடுக்கவும் (உங்களுக்குத் தகுதியான வகைகள் மட்டும் காட்டப்படும்).',
          'தொடக்க மற்றும் முடிவு தேதிகளைத் தேர்ந்தெடுக்கவும். அரை நாள் விடுப்புக்கு, தேதியில் உள்ள AM/PM தேர்வைப் பயன்படுத்தவும்.',
          'அந்த விடுப்பு வகைக்குத் தேவையான விவரங்களை (எ.கா. காரணம்) நிரப்பி, "Submit Application" என்பதைத் தட்டவும்.',
          '"Leave application submitted successfully!" என்ற செய்தி வரும்; கோரிக்கை உங்கள் பட்டியலில் Pending எனத் தோன்றும்.',
        ],
      },
      {
        heading: 'சில விடுப்பு வகைகளுக்குத் தேவையான ஆவணங்கள்',
        items: [
          'Marriage Leave: Profile → Documents → Family Documents-ல் திருமணச் சான்றிதழைப் பதிவேற்றி HR சரிபார்த்த பிறகே திறக்கும். முன்கூட்டியே பதிவேற்றவும்.',
          'Maternity / Paternity Leave: குழந்தையின் பிறப்புச் சான்றிதழை பதிவேற்றி HR சரிபார்த்த பிறகு திறக்கும் (Paternity-க்கு திருமணச் சான்றிதழும் தேவை). Profile → Documents → Family Documents-ல் பதிவேற்றவும்.',
          'Sick / Hospitalisation Leave: விண்ணப்பிக்கும்போது Medical Certificate-ஐ (படம் அல்லது PDF) பதிவேற்றவும். System அதைத் தானாகப் படிக்கும் — படம் தெளிவாக இருக்கட்டும்.',
          'Compassionate Leave: இறப்புச் சான்றிதழைப் பதிவேற்றவும் (30 நாட்களுக்குள் பதிவேற்றலாம்; HR சரிபார்க்கும்).',
          'Home Leave / Urgent Leave (தொழிலாளர்கள்): ஒப்புதல் கிடைத்த பிறகு, HR சரிபார்க்க உங்கள் விமான டிக்கெட்டைப் பதிவேற்றவும்.',
        ],
      },
      {
        text: 'Marriage, Maternity மற்றும் Paternity Leave-க்கு ஆவணம் கட்டாயம். பொருந்தும் சான்றிதழ் profile-ல் பதிவேற்றப்பட்டு HR-ஆல் சரிபார்க்கப்படும் வரை அவை விடுப்பு வகைப் பட்டியலில் தோன்றாது. தேவைப்படும் நேரத்தில் விடுப்பு தயாராக இருக்க, முன்கூட்டியே பதிவேற்றவும்.',
      },
      {
        heading: 'உங்கள் விடுப்பு இருப்பை அறியுங்கள்',
        items: [
          'உங்கள் "Leave Balances" அட்டைகள், ஒவ்வொரு விடுப்பு வகைக்கும் கிடைக்கும் நாட்கள், பயன்படுத்திய நாட்கள் மற்றும் உரிமையைக் காட்டும்.',
          'Annual Leave பெற குறைந்தது 3 மாத சேவை தேவை. அதற்கு முன் (அல்லது முழுவதும் பயன்படுத்திய பின்) விண்ணப்பங்கள் Unpaid Leave ஆகச் சமர்ப்பிக்கப்படும் — இது பொருந்தும்போது பக்கம் தெரிவிக்கும்.',
          'Annual Leave-க்கு விண்ணப்பிக்கும்போது Off in Lieu (OIL) தானாகப் பயன்படுத்தப்படும் (பழையது முதலில்). ஒவ்வொரு OIL credit-க்கும் அட்டையில் தனி expiry date இருக்கும் — காலாவதியான OIL-ஐ மீண்டும் கோர முடியாது என்பதால் முன்பே பயன்படுத்தவும்.',
          'Marriage அல்லது Compassionate Leave போன்ற சில விடுப்பு வகைகள், தகுதி வந்தபின் அல்லது முதலில் பயன்படுத்தும்போது மட்டுமே தோன்றும்.',
        ],
      },
      {
        text: 'Annual Leave எப்படிச் சேர்கிறது: Annual Leave நீங்கள் வேலை செய்யும்போது படிப்படியாக ஈட்டப்படுகிறது — ஜனவரி 1 அன்று முழுவதும் வழங்கப்படாது. முடித்த ஒவ்வொரு சேவை மாதத்திற்கும், உங்கள் வருடாந்திர உரிமையின் ஒரு பகுதி மாதாந்திர சேவைத் தேதி ("monthsary") அருகில் சேர்க்கப்படும். அதனால் balance மாதந்தோறும் உயரும். ஒரு முழு ஆண்டு சேவையை முடித்து work anniversary-ஐ கடந்ததும், முழு வருடாந்திர உரிமை நிலைக்கு வருவீர்கள்; சேவை ஆண்டுகள் அதிகரிக்கும்போது கூடுதல் நாட்களும் கிடைக்கும். தொடக்கத்தில் balance, காட்டப்படும் வருடாந்திர எண்ணைவிடக் குறைவாகத் தோன்றுவதற்குக் காரணம் இதுவே — ஒவ்வொரு மாதத்தையும் முடிக்கும்போது அது உயரும்.',
      },
      {
        text: 'Annual Leave தானாக எப்படிப் பகுக்கப்படுகிறது: நீங்கள் Annual Leave-க்கு விண்ணப்பிக்கும்போது, system ஒரு நிர்ணயிக்கப்பட்ட வரிசையில் balance-களைப் பயன்படுத்தும் — முதலில் நீங்கள் ஈட்டிய Off in Lieu (OIL; முதலில் காலாவதியாகவிருக்கும் credit முதலில்), அடுத்து Annual Leave balance, அவையும் முடிந்தால் மட்டுமே மீதம் Unpaid Leave ஆகும். சமர்ப்பிப்பதற்கு முன் இந்தப் பிரிப்பை form காட்டும் (எ.கா. "2 OIL + 2 AL + 1 UL"); இதனால் சம்பளமில்லாத நாட்கள் எத்தனை என்று முன்பே தெரியும்.',
      },
      {
        heading: 'குறிப்பிட்ட விடுப்பு வகைகளை எப்போது பயன்படுத்துவது',
        items: [
          'External Activity: நிறுவனப் பணிக்காக project location-ல் Clock In/Out செய்ய முடியாத இடத்திற்குச் செல்லும்போது மட்டும் பயன்படுத்தவும் — எ.கா. seminar, conference, அல்லது நிறுவனப் பயணம். Project அல்லது site-ல் வேலை செய்தால் வழக்கம்போல் அங்கே Clock In மற்றும் Clock Out செய்யவும். Activity type-ஐத் தேர்ந்தெடுத்து, location மற்றும் குறுகிய business justification-ஐச் சேர்க்கவும்.',
          'On Course: நிறுவனம் அங்கீகரித்த training/course-ல் கலந்துகொள்ளும்போது விண்ணப்பிக்கவும் — course/training பெயரையும் இடத்தையும் உள்ளிடவும்.',
          'Claim: Off in Lieu: ஓய்வு நாள், ஞாயிறு அல்லது பொது விடுமுறையில் செய்த அங்கீகரிக்கப்பட்ட பணிக்கு OIL கோரவும் — வேலை செய்த தேதியிலிருந்து 30 நாட்களுக்குள் சமர்ப்பிக்க வேண்டும் (இன்றைய தேதிக்கு கோர முடியாது). குறிப்பு: OT பெறத் தகுதியான workmen (தொழிலாளர்கள்) வாரநாள் வழக்கமான நேரத்திற்குப் பிறகான பணிக்கு பணமாக overtime பெறுவதால், அதே பணிக்கு OIL-உம் கோர முடியாது. வாரநாள் after-hours OIL, OT கிடைக்காத staff-க்கு மட்டும்.',
        ],
      },
      {
        heading: 'குடும்ப விடுப்புகள்: Maternity, Paternity, Shared Parental & Childcare',
        items: [
          'Shared Parental Leave (SPL)-க்கு முன் Maternity / Paternity Leave முதலில் பயன்படுத்தப்படும். உங்களுக்கான சட்டப்பூர்வ பெற்றோர் விடுப்பு முழுவதும் முடிந்த பிறகே SPL திறந்து பட்டியலில் தோன்றும்: தாய்களுக்கு Maternity Leave, தந்தைகளுக்கு Paternity Leave. அதற்கு முன் SPL-க்கு விண்ணப்பித்தால், system அதைத் தடுத்து எந்த விடுப்பை முதலில் பயன்படுத்த வேண்டும் என்று தெரிவிக்கும்.',
          'இந்த பெற்றோர் விடுப்புகள் calendar year-ஐ அல்ல, குழந்தையின் பிறந்த தேதியை அடிப்படையாகக் கொண்டவை. பிறந்த நாளிலிருந்து 12 மாதங்களுக்குள் காலாவதியாகும் வரை செல்லுபடியாகும்; அதுவரை மீதமுள்ள balance அடுத்த ஆண்டிற்குச் செல்லலாம்.',
          'Childcare Leave (CCL) ஒவ்வொரு calendar year-க்கும் வழங்கப்படும் உரிமை; ஒவ்வொரு ஜனவரி 1-லும் புதுப்பிக்கப்படும். பயன்படுத்தாத CCL அடுத்த ஆண்டுக்கு எடுத்துச் செல்லப்படாது; பொருந்தும் ஆண்டுக்குள் பயன்படுத்தத் திட்டமிடவும்.',
        ],
      },
      {
        text: 'Home Leave மற்றும் Annual Leave வேறுபாடு: சிங்கப்பூரை விட்டு உங்கள் சொந்த நாட்டிற்குத் திரும்பிச் செல்லும்போது Home Leave பயன்படுத்தவும். சிங்கப்பூரிலேயே இருந்து விடுப்பு எடுக்கும்போது Annual Leave பயன்படுத்தவும். உங்கள் பயணத் திட்டத்துக்குப் பொருந்துவதைத் தேர்ந்தெடுக்கவும்.',
      },
      {
        text: 'ஒரு Home Leave பயணம் அதிகபட்சம் 30 calendar days (அல்லது இந்த ஆண்டு மீதமுள்ள நாட்கள்). தொடக்கத் தேதியைத் தேர்ந்தெடுத்ததும் form சமீபத்திய திரும்பும் தேதியை நிரப்பும். தொடக்கம் மற்றும் திரும்பும் நாள் இரண்டும் கணக்கில் சேரும் — 24 Oct முதல் 24 Nov வரை 32 நாட்கள்; 24 Oct-லிருந்து கடைசி திரும்பும் தேதி 22 Nov.',
      },
      {
        heading: 'நிலையைக் கண்காணிக்க, திருத்த அல்லது ரத்து செய்ய',
        items: [
          'ஒவ்வொரு விண்ணப்பமும் Pending, Approved, Auto Approved, Rejected அல்லது Cancelled என்ற நிலையைக் காட்டும்.',
          'கண் குறியைத் தட்டி "View Details" திறந்து, ஒப்புதல் முன்னேற்றத்தையும் அடுத்து யார் ஒப்புதல் அளிக்க வேண்டும் என்பதையும் பார்க்கலாம்.',
          'Draft-ஐ Edit செய்யலாம்; எதிர்கால Pending கோரிக்கையை Delete செய்யலாம்; Approved கோரிக்கையை Cancel செய்யலாம் (உங்கள் balance திருப்பித் தரப்படும்). ரத்து செய்ய காரணம் அவசியம்.',
        ],
      },
      {
        text: 'முன்கூட்டியே விண்ணப்பிக்கவும். சில விடுப்புகளுக்கு முன் அறிவிப்பு தேவை — Home Leave-க்கு 30 நாட்கள். Urgent Leave-க்கு முன் அறிவிப்பு தேவையில்லை (காத்திருக்க முடியாத அவசரத்திற்கு பயன்படுத்தவும்). தாமதமானால் form எச்சரிக்கும்.',
      },
    ],
  },

  'leave-extension': {
    title: 'Home Leave அல்லது Urgent Leave-ஐ நீட்டித்தல்',
    summary: 'வெளிநாட்டில் இருக்கும்போது மேலும் நாட்கள் தேவையா? அங்கீகரிக்கப்பட்ட Home/Urgent Leave-ல் நாட்களைச் சேர்க்கவும்.',
    routeLabel: 'Leave திறக்கவும்',
    blocks: [
      {
        text: 'அங்கீகரிக்கப்பட்ட Home Leave அல்லது Urgent Leave-ல் இருக்கும்போது திரும்புவதற்கு முன் இன்னும் சில நாட்கள் தேவையா? புதிய விண்ணப்பம் சமர்ப்பிக்காமல், போர்ட்டலுக்குள்ளேயே நீட்டிப்பு கோரலாம். Home Leave மற்றும் Urgent Leave மட்டுமே நீட்டிக்க முடியும்.',
      },
      {
        heading: 'நீட்டிப்பைக் கோருவது',
        items: [
          '"Leave Management" திறந்து, அங்கீகரிக்கப்பட்ட Home Leave/Urgent Leave-ன் கண் குறியைத் தட்டி விவரங்களைப் பார்க்கவும்.',
          'கீழே உள்ள "Home Leave / Urgent Leave Extension" பகுதிக்குச் சென்று "Request Extension" என்பதைத் தட்டவும். (விடுப்பு செயலில் இருக்கும்போது மட்டும் இந்தப் பொத்தான் தோன்றும்.)',
          'New Return Date-ஐத் தேர்ந்தெடுக்கவும் — கூடுதல் நாட்கள் தற்போதைய முடிவு தேதிக்கு அடுத்த நாளிலிருந்து நீங்கள் தேர்ந்தெடுக்கும் புதிய தேதி வரை கணக்கிடப்படும்.',
          'நீட்டிப்பிற்கான குறுகிய Reason-ஐ உள்ளிட்டு (கட்டாயம்), சமர்ப்பிக்கவும்.',
          '"Extension request submitted. Awaiting approval." என்ற செய்தி வரும். உங்கள் மூல விடுப்பை கையாண்ட அதே approver(கள்)-க்கு இது செல்லும்.',
        ],
      },
      {
        heading: 'எப்போது கோரலாம்',
        items: [
          'உங்கள் விடுப்பு முழுமையாக அங்கீகரிக்கப்பட்டிருக்க வேண்டும் — Pending அல்லது Rejected விண்ணப்பத்தை நீட்டிக்க முடியாது.',
          'விடுப்பில் இருக்கும் காலத்தில் மட்டுமே கோரலாம்: தொடக்கத் தேதியன்று/அதற்குப் பிறகு, தற்போதைய முடிவு தேதியன்று/அதற்கு முன். தொடங்கும் முன்போ முடிந்த பிறகோ கோர முடியாது.',
          'முந்தைய extension-ல் அல்லாமல், எப்போதும் மூல விண்ணப்பத்திலேயே கோரவும்.',
          'ஒரே நேரத்தில் ஒரு extension மட்டும் Pending-ல் இருக்கலாம் — அடுத்ததை கோரும் முன் அது Approved அல்லது Rejected ஆகும் வரை காத்திருக்கவும்.',
        ],
      },
      {
        text: 'Home Leave மற்றும் Urgent Leave இரண்டுக்கும் சேர்த்து ஆண்டுக்கு 60 calendar days வரம்பு உண்டு (ஒவ்வொரு ஜனவரி 1-லும் மீட்டமைக்கப்படும்). மீதமுள்ள நாட்களையும் தேர்ந்தெடுக்கக்கூடிய கடைசி return date-ஐயும் form காட்டும் — வரம்பை மீறும் கோரிக்கை தடுக்கப்படும்.',
      },
      {
        heading: 'ஒப்புதல் கிடைத்த பிறகு — புதிய விமான டிக்கெட்டைப் பதிவேற்றவும்',
        items: [
          'ஒப்புதல் கிடைத்ததும் extension அட்டை "Upload Ticket" எனக் காட்டும். அதைத் திறக்க அட்டையைத் தட்டவும்.',
          'HR உங்கள் பயணத்தைச் சரிபார்க்க, புதுப்பிக்கப்பட்ட திரும்பும் விமான டிக்கெட்டைப் பதிவேற்றவும்.',
          'HR பரிசீலிக்கும்போது அட்டை "HR Reviewing" என மாறும்; டிக்கெட் ஏற்றுக்கொள்ளப்பட்டதும் "Activated" ஆகும்.',
        ],
      },
      {
        heading: 'உங்கள் extension-களைக் கண்காணித்தல்',
        items: [
          'ஒவ்வொரு extension-உம் புதிய தேதிகளையும் நிலையையும் காட்டும் தனி அட்டையாக extension பகுதியில் தோன்றும்.',
          'நிலைகள்: "Awaiting Approval" → "Upload Ticket" (ஒப்புதல் கிடைத்தது; டிக்கெட் தேவை) → "HR Reviewing" (டிக்கெட் சமர்ப்பிக்கப்பட்டது) → "Activated" (டிக்கெட் ஏற்றுக்கொள்ளப்பட்டது). "Rejected" அல்லது "Ticket Rejected" என்றால் நீங்கள் நடவடிக்கை எடுக்க வேண்டும்.',
          'மூல விடுப்பிலிருந்து வேறுபடுத்த, இந்தக் கோரிக்கைகளுக்கு உங்கள் leave list-ல் "Extension" badge இருக்கும்.',
        ],
      },
    ],
  },

  'leave-calendar': {
    title: 'விடுப்பு Calendar',
    summary: 'உங்கள் department அல்லது நிறுவனம் முழுவதும் யார் விடுப்பில் உள்ளனர் என்பதைப் பாருங்கள்.',
    routeLabel: 'Leave Calendar திறக்கவும்',
    blocks: [
      {
        heading: 'விடுப்பு அட்டவணையைப் பார்க்க',
        items: [
          'பக்கப்பட்டியில் "Leave Calendar" திறக்கவும்.',
          'மேலே உள்ள toggle மூலம் "Department" மற்றும் "Company" பார்வைகளுக்கு இடையே மாறவும்.',
          'மாதங்களுக்கு இடையே செல்ல அம்புகளைப் பயன்படுத்தவும்; நடப்பு மாதத்திற்குத் திரும்ப "Today" என்பதைத் தட்டவும்.',
          'அன்றைய தினம் விடுப்பில் இருப்பவர்களை department வாரியாகப் பார்க்க எந்தத் தேதியையும் தட்டவும்.',
        ],
      },
      {
        heading: 'தேடலும் வடிகட்டலும்',
        items: [
          'பெயர் அல்லது staff ID மூலம் ஒருவரைக் கண்டுபிடிக்க தேடல் பெட்டியைப் பயன்படுத்தவும்.',
          'குறிப்பிட்ட சக ஊழியர்களைத் தேர்வுசெய்ய filter (funnel) பொத்தானைப் பயன்படுத்தவும் — அடுத்த முறைக்கும் உங்கள் தேர்வு நினைவில் வைக்கப்படும்.',
          'அங்கீகரிக்கப்பட்ட விடுப்புகள் மட்டும் calendar-ல் தோன்றும். பொது விடுமுறைகள் நிறமிட்டு பெயரிடப்படும்.',
        ],
      },
      {
        text: 'தனியுரிமையைப் பாதுகாக்க, சரியான காரணங்களுக்குப் பதிலாக பொதுவான பெயர்களில் (எ.கா. "Out of Office", "Unavailable") விடுப்பு காட்டப்படும். கீழே உள்ள legend நிறங்களை விளக்கும்.',
      },
    ],
  },

  profile: {
    title: 'எனது Profile',
    summary: 'தொடர்பு விவரங்கள், அவசரத் தொடர்புகள் மற்றும் ஆவணங்களைப் புதுப்பித்து வைத்திருங்கள்.',
    routeLabel: 'My Profile திறக்கவும்',
    blocks: [
      {
        heading: 'உங்கள் profile-ல் உள்ளவை',
        items: [
          'மேலே உள்ள தாவல்கள்: Personal, Employment, Compensation, Professional, Legal & Compliance, Documents (பொருந்தினால் Name Card / Skills Upgrading-உம்).',
          'Phone, NRIC, salary, bank போன்ற முக்கியமான புலங்களைக் காட்ட/மறைக்க அருகிலுள்ள கண் குறியைத் தட்டவும்.',
        ],
      },
      {
        heading: 'உங்கள் தொடர்பு விவரங்களைப் புதுப்பிக்க',
        items: [
          '"Personal" தாவலில் "Edit Profile" என்பதைத் தட்டவும்.',
          'உங்கள் personal phone, personal email, residential address மற்றும் unit/postal code-ஐப் புதுப்பிக்கலாம்.',
          'முகவரியைத் திருத்தும்போது postal code-ஐ உள்ளிட்டு, தானாக நிரப்ப "Find Address" என்பதைத் தட்டவும்.',
          'சேமிக்க "Save Changes"; மாற்றங்களைத் தவிர்க்க "Cancel" என்பதைத் தட்டவும்.',
        ],
      },
      {
        heading: 'அவசரத் தொடர்பைச் சேர்க்க',
        items: [
          '"Personal" தாவலில் "Emergency Contacts" பகுதியைக் கண்டுபிடித்து "Add Contact" என்பதைத் தட்டவும்.',
          'முழுப் பெயர், உறவுமுறை மற்றும் குறைந்தது ஒரு phone number-ஐ உள்ளிடவும் (international format பயன்படுத்தவும், எ.கா. +65 9000 0000).',
          'சேமிக்க "Add Contact" என்பதைத் தட்டவும். எப்போது வேண்டுமானாலும் தொடர்புகளைத் திருத்தலாம் அல்லது நீக்கலாம்.',
        ],
      },
      {
        heading: 'ஆவணங்களைப் பதிவேற்றுதல் (Documents தாவல்)',
        items: [
          '"Documents" தாவலைத் திறந்து, "Document Uploads" துணைத் தாவலைத் திறக்கவும்.',
          'பொருத்தமான category-ஐக் கண்டுபிடித்து file-ஐ drop zone-க்கு இழுக்கவும்; அல்லது phone/computer-லிருந்து தேர்ந்தெடுக்க "browse" என்பதைத் தட்டவும்.',
          'File PDF அல்லது image (JPG/PNG) ஆகவும், ஒவ்வொன்றும் அதிகபட்சம் 5MB ஆகவும் இருக்கலாம். ID card-க்கு தெளிவான எடுத்துக்காட்டைப் பார்க்க "Sample" என்பதைத் தட்டவும்.',
          'System உங்கள் file-ஐ OCR மூலம் scan செய்தால், படித்து முடியும் வரை பக்கத்தைவிட்டு செல்ல வேண்டாம். பின்னர் verification pop-up-ல் எடுக்கப்பட்ட விவரங்களைச் சரிபார்த்து HR review-க்கு சமர்ப்பிக்கவும்.',
          'ஒவ்வொரு upload-உம் Processing, Pending HR / Pending Review, Verified அல்லது Rejected என்ற நிலையைக் காட்டும்.',
        ],
      },
      {
        heading: 'எந்த drop zone-ஐப் பயன்படுத்துவது',
        items: [
          'Identity Documents — ID Card (Front), ID Card (Back), Passport, Driving Licence.',
          'Banking Documents — bank statement/letter; இதன் மூலமே bank account புதுப்பிக்கப்படும் (நேரடியாக type செய்யப்படாது).',
          'Education Certificates & Professional Certificates — கல்வித் தகுதிகள் மற்றும் தொழில்முறை சான்றிதழ்கள் (இவை Professional தாவலில் பதிவுகளைச் சேர்க்கும்).',
          'Family Documents — Birth Certificates, Marriage Certificate மற்றும் Compassionate Leave-க்கான death certificate (இவற்றைப் பதிவேற்றுவது Childcare, Maternity, Paternity அல்லது Marriage Leave-ஐத் திறக்கலாம்).',
          'Medical Documents மற்றும் Other Documents — HR கேட்கும் மற்ற ஆவணங்கள்.',
        ],
      },
      {
        text: 'பெயர், அடையாள எண்கள், salary, bank account போன்ற சில விவரங்களைத் துல்லியத்திற்காக HR பராமரிக்கிறது. Bank account-ஐ மாற்ற, நேரடியாகத் திருத்தாமல் Documents → Banking Documents-ல் bank document-ஐப் பதிவேற்றவும்.',
      },
      {
        heading: 'Skills Upgrading (தொழிலாளர்கள்)',
        items: [
          'தொழிலாளர்களின் Profile-ல் "Skills Upgrading" தாவல் இருக்கும். அதில் construction classification: skill level, மொத்த construction experience, மாதாந்திர foreign-worker levy மற்றும் source country காட்டப்படும்.',
          '"Current BCA Registrations" உங்கள் trade registration-களை (எ.கா. CoreTrade, Multi-skilling), அவற்றின் expiry dates உடன் காட்டும்; ஒன்று விரைவில் காலாவதியாகவிருந்தாலோ ஏற்கனவே காலாவதியானாலோ எச்சரிக்கும்.',
          '"Upgrade Pathways" நீங்கள் தகுதி பெறக்கூடிய வழிகளையும் ஒவ்வொரு requirement-ஐயும் (experience, salary, skills assessment) சரிபார்த்து, upgrade செய்ய இன்னும் என்ன தேவை என்பதைக் காட்டும்.',
          'இந்தத் தாவல் தகவலுக்காக மட்டும்; மாற்ற முடியாது. விவரம் தவறாக இருந்தாலோ upgrade தொடர விரும்பினாலோ HR-ஐ அணுகவும்.',
        ],
      },
      {
        heading: 'Digital Name Card (staff & directors)',
        items: [
          '"Legal & Compliance" தாவலுக்குச் சென்று "Digital Name Card Consent" பகுதியைக் கண்டுபிடிக்கவும்.',
          'பகிர விரும்பும் business fields-ஐ இயக்கவும் (எ.கா. designation, department, work email/phone). உங்கள் முழுப் பெயர் எப்போதும் சேர்க்கப்படும்.',
          'தேர்ந்தெடுத்த புலங்கள் தனிப்பட்ட link மற்றும் QR code மூலம் பொதுவாகக் கிடைக்கும் என்பதை ஏற்கும் பெட்டியைத் தேர்ந்தெடுத்து, "Activate Name Card" என்பதைத் தட்டவும்.',
          'பின்னர் "Name Card" தாவல் தோன்றும். அதில் QR code-ஐப் பகிரலாம், link-ஐ copy செய்யலாம், card-ஐ pause செய்யலாம் அல்லது link-ஐ மீண்டும் உருவாக்கலாம்.',
        ],
      },
      {
        text: 'Digital name card உங்கள் விருப்பமும் ஒப்புதலும் இருந்தால் மட்டுமே இயங்கும் — activate செய்யும் வரை எதுவும் பகிரப்படாது. NRIC/FIN, passport, வீட்டு முகவரி, personal email, salary போன்ற தனிப்பட்ட விவரங்கள் ஒருபோதும் சேர்க்கப்படாது; எப்போது வேண்டுமானாலும் ஒப்புதலைத் திரும்பப் பெறலாம்.',
      },
    ],
  },

  'staff-directory': {
    title: 'Staff Directory',
    summary: 'சக ஊழியர்களைக் கண்டுபிடித்து நிறுவன அமைப்பைப் பாருங்கள்.',
    routeLabel: 'Staff Directory திறக்கவும்',
    blocks: [
      {
        heading: 'சக ஊழியரைக் கண்டுபிடிக்க',
        items: [
          'பக்கப்பட்டியில் "Staff Directory" திறக்கவும்.',
          'பெயர், staff ID, work email அல்லது designation மூலம் தேடவும்.',
          'Department அடிப்படையில் குறைக்க filter பொத்தானைப் பயன்படுத்தவும்.',
          'ஒருவரின் அட்டையைத் திறந்து work email மற்றும் phone-ஐப் பார்க்க அவரைத் தட்டவும் (email/அழைக்க அதைத் தட்டலாம்).',
        ],
      },
      {
        heading: 'பார்க்கும் முறைகள்',
        items: [
          'Grid View: சக ஊழியர் அட்டைகள் (default).',
          'List View: reporting officer உட்பட சுருக்கமான table.',
          'Organization Chart: reporting hierarchy-ஐப் பார்க்கலாம்; PDF ஆக download செய்யலாம்.',
        ],
      },
      {
        text: 'பணி தொடர்பு விவரங்கள் மட்டுமே காட்டப்படும். Personal phone, வீட்டு முகவரி மற்றும் அடையாள எண்கள் சக ஊழியர்களுக்கு ஒருபோதும் தெரியாது.',
      },
    ],
  },

  'my-assets': {
    title: 'எனது Assets',
    summary: 'உங்களுக்கு ஒதுக்கப்பட்ட நிறுவன உபகரணங்களைப் பார்த்து transfer/return-களைச் செய்யுங்கள்.',
    routeLabel: 'My Assets திறக்கவும்',
    blocks: [
      {
        heading: 'நீங்கள் காண்பவை',
        items: [
          '"My Assets" தாவல்: தற்போது உங்களுக்கு ஒதுக்கப்பட்ட அனைத்தும் category வாரியாக (IT, Access, Fleet போன்றவை).',
          '"Transactions" தாவல்: நீங்கள் நடவடிக்கை எடுக்க வேண்டியவை மற்றும் முந்தைய asset history. காத்திருக்கும் பதிவுகளின் எண்ணிக்கை badge-ல் தெரியும்.',
        ],
      },
      {
        heading: 'உங்களுக்கு வழங்கப்பட்ட உபகரணத்தைப் பெற்றதை உறுதிசெய்ய',
        items: [
          '"Transactions" தாவலுக்குச் செல்லவும்.',
          '"Needs your action" கீழ் item-ஐக் கண்டுபிடித்து "Acknowledge receipt" என்பதைத் தட்டவும்.',
          'பொறுப்பு அறிவிப்பைப் படித்து tick செய்து உறுதிசெய்யவும். Asset இப்போது "My Assets" கீழ் தோன்றும்.',
        ],
      },
      {
        heading: 'சக ஊழியரிடமிருந்து transfer-ஐ ஏற்க',
        items: [
          '"Transactions"-ல் incoming transfer-ஐத் திறந்து "Accept" என்பதைத் தட்டவும்.',
          'நிலையைத் தேர்ந்தெடுக்கவும் (New / Good / Fair / Poor / Faulty).',
          'Item-ன் குறைந்தது ஒரு photo-வைச் சேர்த்து "Accept Transfer" என்பதைத் தட்டவும்.',
        ],
      },
      {
        heading: 'Asset-ஐத் திருப்பித் தர',
        items: [
          '"My Assets"-ல் item-ஐத் திறந்து "Return to Inventory" என்பதைத் தட்டவும்.',
          'காரணத்தைத் தேர்ந்தெடுத்து (தேவைப்பட்டால் notes சேர்த்து), "Request Return" என்பதைத் தட்டவும்.',
          'முழுமைப்படுத்த, asset custodian பொருளை நேரடியாகப் பெற்றதை உறுதிசெய்வார்.',
        ],
      },
      {
        text: 'Asset-ஐப் பெற்றதாக உறுதிசெய்யும்போது அல்லது transfer-ஐ ஏற்கும்போது, system உங்கள் பதிவுக்காக கையொப்பமிட்ட acknowledgement letter (PDF) உருவாக்கும். Asset-ஐத் திறந்து "View acknowledgement letter" என்பதைத் தட்டி எப்போது வேண்டுமானாலும் பார்க்கலாம் அல்லது download செய்யலாம்.',
      },
      {
        text: 'Transfers மற்றும் returns 7 நாட்களுக்குள் முடிக்கப்படாவிட்டால் காலாவதியாகும். "(Expiring soon!)" எனக் குறிக்கப்பட்டவற்றுக்கு 24 மணிநேரத்திற்கும் குறைவாகவே உள்ளது.',
      },
    ],
  },

  payslips: {
    title: 'சம்பளச் சீட்டுகள்',
    summary: 'உங்கள் விரிவான சம்பள அறிக்கைகளைப் பார்த்து download செய்யுங்கள்.',
    routeLabel: 'Payslips திறக்கவும்',
    blocks: [
      {
        heading: 'சம்பளச் சீட்டைப் பார்க்கவும் download செய்யவும்',
        items: [
          'பக்கப்பட்டியில் "Payslips" திறக்கவும்.',
          '"Choose a month" கீழ் தேவையான ஆண்டு மற்றும் மாதத்தைத் தேர்ந்தெடுக்கவும் (payslip உள்ள மாதங்கள் highlight செய்யப்படும்).',
          'Earnings, deductions, net pay உட்பட முழு விவரங்களைக் காண "Preview" என்பதைத் தட்டவும்.',
          'Download செய்ய "PDF" என்பதைத் தட்டவும். Preset-கள் (Last 3 / 6 / 12 months) மூலம் பல மாதங்களை ஒரே PDF-ஆகவும் சேர்க்கலாம்.',
        ],
      },
      {
        heading: 'தெரிந்திருக்க வேண்டியவை',
        items: [
          'மற்றவர்கள் திரையைப் பார்க்கக்கூடும் என்றால் தொகைகளைக் காட்ட/மறைக்க கண் குறியைப் பயன்படுத்தவும்.',
          'அந்த மாத payroll அங்கீகரிக்கப்பட்டு வெளியிடப்பட்ட பிறகே payslip தோன்றும் — தயாரானதும் அறிவிப்பு வரும்.',
          'ஆண்டின் totals அட்டை, net pay, gross, deductions மற்றும் overtime-ஐக் காட்டும்.',
        ],
      },
      {
        text: 'Digital payslip portal தற்போது தொழிலாளர்களுக்குக் கிடைக்கிறது. நீங்கள் staff ஆக இருந்து "Coming Soon" செய்தியைக் கண்டால், உங்கள் online payslip-கள் தயாராகிக் கொண்டிருக்கின்றன.',
      },
    ],
  },

  'petty-cash': {
    title: 'Petty Cash கோரிக்கைகள்',
    summary: 'செலவுக் கோரிக்கைகளைச் சமர்ப்பித்து கண்காணியுங்கள்.',
    routeLabel: 'Petty Cash திறக்கவும்',
    blocks: [
      {
        text: 'Petty Cash தனி application-ஆக இயங்குகிறது. பக்கப்பட்டியில் "Petty Cash Claims" என்பதைத் தட்டினால் single sign-on மூலம் தானாக உள்நுழைந்து, கோரிக்கைகளைச் சமர்ப்பித்து கண்காணிக்கும் Petty Cash app திறக்கும். தானாகத் திறக்காவிட்டால், திரையில் "Open Petty Cash" பொத்தானைத் தட்டவும்.',
      },
      {
        text: 'Dental claims (Employee Handbook Clause 8) confirmed staff-க்கு மட்டும். Probation காலத்திலும் மற்ற petty cash claims சமர்ப்பிக்கலாம்; confirmation-க்குப் பிறகு dental reimbursement திறக்கும் (ஆண்டுக்கு S$150 வரம்பு).',
      },
    ],
  },

  'ro-approvals': {
    title: 'Reporting Officers: விடுப்பை அங்கீகரித்தல்',
    summary: 'உங்கள் குழுவின் விடுப்புக் கோரிக்கைகளைப் பரிசீலித்து அங்கீகரிக்கவும் அல்லது நிராகரிக்கவும்.',
    routeLabel: 'Dashboard-க்குச் செல்லவும்',
    blocks: [
      {
        text: 'விடுப்பு approvals உங்கள் Dashboard-ல் "My Approvals" கீழ் செய்யப்படும். கோரிக்கைகள் காத்திருக்கும்போது அறிவிப்பும் (🔔), Dashboard-ல் எண்ணிக்கை badge-உம் வரும்.',
      },
      {
        heading: 'கோரிக்கையை அங்கீகரிக்க அல்லது நிராகரிக்க',
        items: [
          'Dashboard திறந்து "My Approvals" அட்டையைக் கண்டுபிடிக்கவும்.',
          'கோரிக்கையின் கண் குறியைத் தட்டி "Leave Application Details" திறக்கவும்.',
          'தேதிகள், காரணம் மற்றும் "Team availability" குறிப்பைப் பரிசீலிக்கவும் (அதே நேரத்தில் மற்றவர்கள் விடுப்பில் இருந்தால் இது எச்சரிக்கும்).',
          'அங்கீகரிக்க பச்சை "Approve" பொத்தானைத் தட்டவும். பல நிலை workflow என்றால் அடுத்த approver-க்கு செல்லும்.',
          'நிராகரிக்க "Reject" என்பதைத் தட்டி, காரணத்தை (கட்டாயம்) உள்ளிட்டு "Confirm Rejection" என்பதைத் தட்டவும்.',
        ],
      },
      {
        heading: 'சிறப்பு நிலைகள்',
        items: [
          'National Service Leave: approve/reject செய்ய முடியாது — தெரிந்துகொண்டதை உறுதிசெய்ய "Acknowledge" என்பதைத் தட்டவும்.',
          'Sick / medical leave: HR முதலில் ஆவணத்தைச் சரிபார்க்கும் வரை பொத்தான்கள் இல்லாமல் "Awaiting HR Verification" தோன்றலாம்.',
          'அறிவிப்பைத் தட்டினால் கோரிக்கை நேரடியாகத் திறக்கும். ஏற்கனவே முடிவு செய்யப்பட்டிருந்தால், அது இனி pending இல்லை என்று தெரிவிக்கப்படும்.',
        ],
      },
      {
        text: 'உங்கள் குழுவின் attendance மற்றும் wellbeing-ஐ விரிவாகப் பார்க்க பக்கப்பட்டியில் "My Team" பயன்படுத்தவும். குறிப்பு: approvals Dashboard-ல் செய்யப்பட வேண்டும்; My Team-ல் அல்ல.',
      },
    ],
  },

  'my-team': {
    title: 'எனது குழு (Reporting Officers & HODs)',
    summary: 'குழுவின் attendance, leave, 72-hour OT cap மற்றும் 12-day rest-day compliance-ஐ ஒரே பார்வையில் காணுங்கள்.',
    routeLabel: 'My Team திறக்கவும்',
    blocks: [
      {
        heading: 'நீங்கள் பார்க்கக்கூடியவை',
        items: [
          'Overview: உங்களுக்கு நேரடியாக report செய்பவர்களின் attendance மற்றும் கவனிக்க வேண்டியவை.',
          'Trends: காலப்போக்கில் attendance patterns.',
          'Leave Insights: தற்போது விடுப்பில் இருப்பவர்களும் உங்கள் குழுவின் வரவிருக்கும் விடுப்புகளும்.',
          'Individual: ஒரு குழு உறுப்பினரின் attendance விவரங்களைப் பார்க்க.',
          'Big Five: career/coaching உரையாடல்களுக்கான personality profiles (காரணம் கட்டாயம்; employee access log-ஐப் பார்ப்பார்). HODs மற்றும் Deputies முழு department-ஐப் பார்ப்பார்கள்; ROs நேரடி reports-ஐ மட்டும் பார்ப்பார்கள்.',
          'Overtime: MOM மாதாந்திர 72 மணி overtime வரம்பை நோக்கி உங்கள் குழுவின் நிலை (workmen மட்டும் — கீழே பார்க்கவும்).',
          'Rest Day: MOM 12 நாள் rest-day வரம்பை ஒப்பிட்டு குழுவின் தொடர்ச்சியான வேலை நாட்கள் (கீழே பார்க்கவும்).',
          'HODs-க்கு "Department" தாவலும் கிடைக்கும்; "Direct Reports" மற்றும் முழு department இடையே மாறலாம்.',
        ],
      },
      {
        heading: 'Rest Day அல்லது Overtime கண்காணிப்பைத் திறக்க',
        items: [
          'பக்கப்பட்டியில் "My Team" என்பதைத் தட்டவும் (அல்லது நேரடியாக /team-dashboard செல்லவும்).',
          'பக்கத்தின் மேலே "Rest Day" அல்லது "Overtime" தாவலைத் தட்டவும்.',
          'Direct link-ஐ bookmark/share செய்யலாம்: rest-day கண்காணிப்புக்கு /team-dashboard?tab=restday; 72-hour cap பார்வைக்கு /team-dashboard?tab=overtime.',
          'Table-ஐ filter செய்ய summary card-ஐத் தட்டவும் (எ.கா. "Action Required"); அல்லது ஒருவரின் விவரத்தைத் திறக்க row-வில் கண் குறியைத் தட்டவும்.',
        ],
      },
      {
        heading: 'Rest Day தாவல் — 12 நாள் வரம்பு (MOM Employment Act s36)',
        items: [
          'ஒவ்வொரு குழு உறுப்பினரும் ஓய்வு நாள் இல்லாமல் தொடர்ந்து எத்தனை calendar days வேலை செய்துள்ளார் என்பதைக் காட்டும். சட்டப்பூர்வ அதிகபட்சம் 12; 13-வது தொடர்ச்சியான வேலை நாளில்தான் மீறல் ஏற்படும்.',
          'நிலை நிறங்கள்: OK (<7 நாட்கள்), Watch (7–8), Warning (9–11), Critical (12 — உச்ச வரம்பு; அடுத்த வேலை நாளுக்கு முன் ஓய்வு அவசியம்), Violated (13+).',
          'வரம்பை நெருங்குபவருக்கு table "Rest by …" தேதியைக் காட்டும் — விதிமுறைக்குள் இருக்க அவர் ஓய்வெடுக்க வேண்டிய கடைசி நாள்.',
          'ஒருவரின் விவரத்தைத் திறந்து 30 நாள் work/rest timeline, alert history மற்றும் "Rest day required by" - "Projected next rest day" கணிப்பைப் பார்க்கலாம் (schedule, approved leave, public holidays அடிப்படையில்). தேதிகள் பொருந்தாவிட்டால், deadline-க்கு முன் rest day ஒதுக்க வேண்டும் என்று system எச்சரிக்கும்.',
          'Managers-க்கு read-only — இங்கே alerts-ஐ acknowledge செய்ய முடியாது (admin Rest Day Monitoring பக்கத்தில் HR கையாளும்). சிக்கலை முன்கூட்டியே கண்டறிந்து குழுவுடன் rest day திட்டமிட இதைப் பயன்படுத்தவும்.',
        ],
      },
      {
        heading: 'Overtime தாவல் — மாதாந்திர 72 மணி வரம்பு (MOM Part IV)',
        items: [
          'உங்கள் குழுவில் உள்ள workmen-க்கு MOM மாதாந்திர 72 மணி வரம்பில் கணக்காகும் overtime மணிநேரத்தைக் கண்காணிக்கும். Overtime excess மட்டும் கணக்காகும் — rest days/public holidays-ல் regular hours சேராது.',
          'உங்களின் கீழ் குறைந்தது ஒரு OT-க்கு தகுதியான workman இருந்தால் மட்டுமே இந்தத் தாவல் தோன்றும். Staff-class employees மட்டும் இருந்தால் இது தெரியாது.',
          'Dropdown-ல் மாதத்தைத் தேர்ந்தெடுக்கவும் (default: நடப்பு மாதம்). மாதம் நடந்துகொண்டிருக்கும்போது புதிய எண்ணிக்கை தேவைப்பட்டால் refresh பொத்தானைப் பயன்படுத்தவும்.',
          'நிலை வரம்புகள்: OK (<48h), At Risk (48–60h), Critical (60–72h), Exceeded (>72h). நடப்பு மாதத்தில், கணிப்பு month-end-க்கு முன் வரம்பை எட்டலாம் என்றால் "Watch" அல்லது "Projected Exceed" என்பதும் தோன்றலாம்.',
          'ஒருவரின் தினசரி breakdown மற்றும் 12-month trend-ஐத் திறக்க row-ஐத் தட்டவும். Compliance-க்கு முக்கியமான எண் "72h Cap OT" column.',
          'Workmen தங்களின் cap progress-ஐ Attendance பக்கத்தில் காண்பார்கள் ("Clock In & Out" பார்க்கவும்). Managers முழுக் குழுவையும் இத்தாவலில் கண்காணிப்பார்கள்.',
        ],
      },
      {
        text: 'My Team தகவலுக்காக மட்டும். விடுப்பை approve/reject செய்ய Dashboard-ல் "My Approvals" பயன்படுத்தவும் ("Reporting Officers: விடுப்பை அங்கீகரித்தல்" பார்க்கவும்).',
      },
    ],
  },

  'self-service': {
    title: 'Self-Service மையம்',
    summary: 'கோரிக்கைகள், தகவல் வளங்கள், நிகழ்வுகள் மற்றும் பலவற்றுக்கான ஒரே இடம்.',
    routeLabel: 'Self-Service திறக்கவும்',
    blocks: [
      {
        heading: 'இங்கே கிடைப்பவை',
        items: [
          'Requests & Approvals: Request Letters, Nightwork, Rest Day & PH Work, Course Requests மற்றும் Overseas Travel Notice; உங்கள் பொறுப்பைப் பொறுத்து Worker Trade Transfer, Work Pass Decisions, offboarding அட்டைகளும் தோன்றும்.',
          'Resources: Employee Handbook, Company Policies மற்றும் Training Materials.',
          'Events: Meetings & Training நடத்தி attendance பதிவு செய்ய.',
          'Personal Insights (விருப்பமானது & ரகசியமானது): Big Five profile.',
          'Report a Concern: Anonymous Misconduct Reporting.',
        ],
      },
      {
        text: 'பக்கப்பட்டியில் "Self-Service" திறந்து, தேவையான அட்டையைத் தட்டவும். Worker Trade Transfer போன்ற சில அட்டைகள் உங்கள் பொறுப்புக்குப் பொருந்தினால் மட்டுமே தோன்றும்.',
      },
    ],
  },

  letters: {
    title: 'கடிதங்களைக் கோருதல்',
    summary: 'நிறுவனம்/HR கடிதங்களைக் கோரி, தயாராகும் வரை கண்காணியுங்கள்.',
    routeLabel: 'Request Letters திறக்கவும்',
    blocks: [
      {
        heading: 'கடிதத்தைக் கோர',
        items: [
          'Self-Service → "Request Letters" திறக்கவும்.',
          '"Create New Request" கீழ் Letter Type-ஐத் தேர்ந்தெடுக்கவும்: "Employment Verification" அல்லது "Home Leave Authorization".',
          'Employment Verification-க்கு Purpose-ஐத் தேர்ந்தெடுக்கவும் (எ.கா. Visa Application, Bank Loan, Tenancy Agreement); "Other" என்றால் விவரிக்கவும்.',
          '"Create Request" என்பதைத் தட்டி, "Submit Request" மூலம் உறுதிசெய்யவும். HR approval-க்கு அனுப்பப்படும்.',
        ],
      },
      {
        heading: 'கண்காணித்து download செய்ய',
        items: [
          'உங்கள் கோரிக்கைகள் "My Requests" கீழ் Pending Approval, Approved, Rejected அல்லது Cancelled என்ற நிலையில் தோன்றும்.',
          'Approved ஆனதும் preview/download குறிகள் மூலம் PDF கடிதத்தைப் பெறலாம்.',
          'கடிதங்கள் 60 நாட்கள் செல்லுபடியாகும். காலாவதியானால், புதிய கோரிக்கையை முன்நிரப்ப "Request a new letter" பயன்படுத்தவும்.',
          'Pending Approval நிலையில் இருக்கும் வரை கோரிக்கையை cancel செய்யலாம்.',
        ],
      },
    ],
  },

  'shift-requests': {
    title: 'Nightwork & Rest Day Work Requests',
    summary: 'இரவு, ஓய்வு நாள் அல்லது PH பணிக்குப் பின் தொழிலாளர்களுக்கு அடுத்த காலை/நாள் ஓய்வு தேவைப்பட்டால் முன் ஒப்புதல் பெறுங்கள்.',
    routeLabel: 'Nightwork Requests திறக்கவும்',
    blocks: [
      {
        text: 'இந்தக் கோரிக்கைகள் தொழிலாளர் குழுவின் சார்பில் உருவாக்கப்படுகின்றன — உங்களுக்காக அல்ல. தொழிலாளர்கள் சமர்ப்பிக்க மாட்டார்கள்; அங்கீகரிக்கப்பட்ட அட்டவணையை "My Assignments" தாவலில் பார்ப்பார்கள். (Rest Day & PH work: Self-Service → "Rest Day & PH Work Request".)',
      },
      {
        heading: 'யார் சமர்ப்பிக்க வேண்டும்',
        items: [
          'Nightwork: Trade Leaders, Managers அல்லது HR அனுமதி வழங்கியவர். (Reporting Officers/HODs, Trade Leader அல்லது Manager ஆகவும் இருந்தால் மட்டுமே சமர்ப்பிப்பார்கள்.)',
          'Rest Day / PH Work: Trade Leaders, Managers, Reporting Officers (நேரடி reports உள்ளவர்கள்), அல்லது HR அனுமதி பெற்றவர்கள்.',
          'Department-ன் Deputy HOD, பின்னர் HOD approval அளிப்பார்கள்.',
        ],
      },
      {
        heading: 'எப்போது கோர வேண்டும்',
        items: [
          'முடிவு விதி: பணியால் அடுத்த காலை அல்லது அடுத்த நாள் ஓய்வு/recovery (AM Only அல்லது Full Day) தேவைப்பட்டால் கோரவும். இந்த recovery-தான் இதை சாதாரண overtime-லிருந்து வேறுபடுத்துகிறது.',
          'Nightwork: குழு night shift வேலை செய்யும்போது, அல்லது வழக்கமான நேரத்தைக் கடந்து இரவு வரை வேலை செய்து அடுத்த நாள் ஓய்வெடுக்கும்போது பயன்படுத்தவும். வழக்கமான பகல் பணிக்குப் பின் என்றால் "Extension"; பகல் shift-ஐ இரவுப்பணி மாற்றினால் "Standard". தாமதமாக முடித்தாலும் அடுத்த நாள் வழக்கமான முழு நாள் வேலை செய்தால் Nightwork பயன்படுத்த வேண்டாம் — அது சாதாரண OT.',
          'Rest Day / PH Work: தொழிலாளர்கள் ஓய்வு நாள் அல்லது public holiday-ல் வேலை செய்யும்போதெல்லாம் பயன்படுத்தவும். அவர்களின் work schedule-படி 6 நாள் வாரம் (திங்கள்–சனி), எனவே பொதுவாக rest day ஞாயிறு. Shift காரணமாக அடுத்த காலை/நாள் ஓய்வு தேவைப்பட்டால் Full Day அல்லது AM Only; அடுத்த நாள் வழக்கமான வேலை நாள் என்றால் மட்டும் None.',
          'Hours, recovery, workers முன்கூட்டியே அங்கீகரிக்கப்பட, முன்னதாகச் சமர்ப்பிக்கவும். அவசரம் என்றால் backdate செய்யலாம்; காரணம் கூற வேண்டும். Payroll-க்கு lock ஆன தேதிகள் தடுக்கப்படும் (HR-ஐ அணுகவும்).',
        ],
      },
      {
        text: 'தொழிலாளர்கள் எப்போதும் வழக்கம்போல் Clock In மற்றும் Clock Out செய்ய வேண்டும் — இதில் மாற்றமில்லை. Recovery என்பது nightwork அல்லது rest-day/PH work தேதிக்கு அடுத்த நாள்: AM Only என்றால் மதிய உணவுக்குப் பிறகு திரும்புதல்; Full Day என்றால் முழு நாள் ஓய்வு.',
      },
      {
        heading: 'கோரிக்கையைச் சமர்ப்பிப்பது எப்படி',
        items: [
          'Self-Service → "Nightwork Requests" அல்லது "Rest Day & PH Work Request" திறந்து, "New Request" தாவலுக்குச் செல்லவும்.',
          'Step 1 — Project & Description: project-ஐத் தேர்ந்தெடுத்து பணியை விவரிக்கவும்.',
          'Step 2 — Dates & Times: தேதிகள், start/end times மற்றும் recovery day-ஐத் தேர்ந்தெடுக்கவும் (Full Day, AM Only, அல்லது rest day work-க்கு None).',
          'Step 3 — Personnel: தொழிலாளர்களை (பெயர்/staff ID மூலம் தேடவும்) மற்றும் safety personnel-ஐச் சேர்க்கவும்.',
          'Step 4 — Review & Submit: summary-ஐச் சரிபார்த்து "Submit for Approval" என்பதைத் தட்டவும்.',
          '"My Requests" கீழ் முன்னேற்றத்தைக் கண்காணிக்கவும் — Pending Dy HOD → Pending HOD → Approved எனத் தெரியும்.',
        ],
      },
      {
        text: 'Rest day work, MOM தொடர்ச்சியான 12 வேலை நாள் வரம்பைச் சரிபார்க்கும். தொழிலாளர் அதை மீறினால், தொடர்வதற்கான நியாயத்தை விளக்கும் override reason-ஐ உள்ளிட வேண்டும்.',
      },
    ],
  },

  'trade-transfer': {
    title: 'தொழிலாளர் Trade Transfer',
    summary: 'நீங்கள் வழிநடத்தும் trade-க்கு தொழிலாளர்களை மாற்றி, தொடர்புடைய அனைவரிடமும் acknowledgement பெறுங்கள்.',
    routeLabel: 'Worker Trade Transfer திறக்கவும்',
    blocks: [
      {
        text: 'Trade Leader தாம் வழிநடத்தும் trade-க்கு தொழிலாளர்களைக் கொண்டுவர transfer உருவாக்குவார். ஒவ்வொரு தொழிலாளருக்கும் தற்போதைய Trade Leader, தொழிலாளர், HOD ஆகியோர் அந்த வரிசையில் தனித்தனியாக acknowledge செய்வார்கள். HR-க்கு read-only oversight மட்டுமே; approval chain-ல் இல்லை.',
      },
      {
        heading: 'யார், எப்போது',
        items: [
          'யார் கோருவது: தொழிலாளர்களைப் பெறவிருக்கும் Trade Leader (incoming leader). HR admins-க்கு read-only "All Requests" பார்வை உண்டு.',
          'யார் acknowledge செய்வது: தொழிலாளரின் தற்போதைய Trade Leader, பின்னர் தொழிலாளர், பின்னர் HOD — இதே வரிசையில்.',
          'எப்போது: staffing/project தேவைக்காக ஒருவரையோ பலரையோ தற்போதைய trade-லிருந்து நீங்கள் வழிநடத்தும் trade-க்கு மாற்றும்போது.',
        ],
      },
      {
        heading: 'Transfer கோருவது எப்படி',
        items: [
          'Self-Service → "Worker Trade Transfer" → "Request Transfer" தாவலைத் திறக்கவும்.',
          'மாற்ற வேண்டிய trade-ஐ (ஒன்றுக்கு மேற்பட்டதை வழிநடத்தினால்) மற்றும் effective date-ஐ (இன்று அல்லது பின்னர்) தேர்ந்தெடுக்கவும்.',
          'தொழிலாளர்களை (பெயர், staff ID அல்லது trade மூலம் தேடவும்) சேர்த்து காரணத்தை உள்ளிடவும்.',
          '"Submit Request" என்பதைத் தட்டவும். "My Requests" கீழ் ஒவ்வொரு தொழிலாளரையும் கண்காணிக்கலாம்; நடந்துகொண்டிருக்கும்போது "Cancel Request" செய்யலாம்.',
        ],
      },
      {
        heading: 'Acknowledge செய்யுமாறு கேட்டால்',
        items: [
          'Notification, Dashboard card அல்லது "My Inbox" தாவலில் கோரிக்கையைத் திறந்து "Review" என்பதைத் தட்டவும்.',
          'தொழிலாளர்கள்: உங்களுக்குத் தெரியும் என்பதை உறுதிசெய்ய "Accept"; transfer-ஐ நிறுத்த "Decline" (காரணம் கட்டாயம்) என்பதைத் தட்டவும்.',
          'தற்போதைய Trade Leader / HOD: "Approve" அல்லது "Reject" என்பதைத் தட்டவும் (reject செய்ய காரணம் கட்டாயம்).',
          'உங்கள் முடிவைப் பதிவு செய்ய "Confirm" என்பதைத் தட்டவும்.',
        ],
      },
      {
        text: 'ஒவ்வொரு தொழிலாளரும் தனித்தனியாக கையாளப்படுவார் — ஒருவர் rejected ஆனாலும் மற்ற batch தொடரும். மூவரும் acknowledge செய்ததும் trade change திட்டமிடப்பட்டு effective date அன்று செயல்படும்.',
      },
    ],
  },

  'passport-return': {
    title: 'Passport திருப்பி வழங்குதல்',
    summary: 'முன்பு HR வைத்திருந்த passport-களைத் திருப்பி வழங்கி, ஒவ்வொரு தொழிலாளரும் பெற்றதைப் பதிவு செய்யுங்கள்.',
    routeLabel: 'Passport Return திறக்கவும்',
    blocks: [
      {
        heading: 'இந்த campaign செய்வது என்ன',
        items: [
          'Passport ஏற்கனவே அவர்களிடமே உள்ளது என்று HR உறுதிசெய்த தொழிலாளர்களைத் தவிர, செயலில் உள்ள எல்லா தொழிலாளர்களின் passport-களையும் HR வைத்துள்ளது. அவர்களுக்கு physical return இல்லை. Malaysian WP வைத்திருப்பவர்கள் இந்த campaign-ல் இல்லை—அவர்களின் passport ஒருபோதும் HR-இடம் வைக்கப்படவில்லை; அவர்கள் acknowledge செய்ய வேண்டியதில்லை.',
          'வைத்திருக்கும் passport நிரந்தரமாகத் தொழிலாளரிடம் திருப்பித் தரப்படும்; மீண்டும் நிறுவனப் பாதுகாப்பிற்கு எடுத்துக்கொள்ளக் கூடாது.',
          'விடுப்பில் உள்ள தொழிலாளர்கள் திரும்பிய பின் policy-ஐ acknowledge செய்வார்கள். ஏற்கனவே passport-ஐ எடுத்துச் சென்றவர்கள் இப்போது acknowledge செய்வார்கள்—இரண்டாவது physical handover இல்லை.',
          'தொழிலாளர் விதிமுறைகளில் கையொப்பமிடுவது/acknowledge செய்வது physical return-க்கான நிபந்தனை அல்ல.',
          'Acknowledge செய்த பிறகு, பதிவு செய்யப்பட்ட confirmations மற்றும் acknowledge செய்த சரியான மொழிப் பதிப்பைப் பார்க்க Passport Return-ஐ எப்போது வேண்டுமானாலும் மீண்டும் திறக்கலாம். வேறு மொழியில் acknowledge செய்தவர் English reference-க்கும் மாறலாம்; இது பதிவு செய்யப்பட்ட மொழியை மாற்றாது.',
          'பதிவுசெய்யப்பட்ட எல்லா records-உம் acknowledge செய்யப்பட்டதும் அல்லது witness exception மூலம் தீர்க்கப்பட்டதும் campaign தானாக முடிவடையும்.',
        ],
      },
      {
        heading: 'தொழிலாளர்கள் (passport HR-இடம் இருந்தால்)',
        items: [
          'உங்கள் original passport தயாராக உள்ளது என்று HR தெரிவிக்கும் வரை காத்திருக்கவும்.',
          'Portal-ல் எதையும் உறுதிசெய்யும் முன், original passport-ஐப் பெற்று சரிபார்க்கவும்.',
          'Passport Return திறந்து, மொழியைத் தேர்ந்தெடுத்து, passport மற்றும் overseas travel பொறுப்புகளைப் படிக்கவும்.',
          'Passport-ஐ நேரடியாகப் பெற்றதை உறுதிசெய்து policy-ஐ acknowledge செய்யவும். பயன்படுத்திய மொழிப் பதிப்பும் timestamp-உம் audit record-ல் சேமிக்கப்படும்.',
          'நீங்கள் உறுதிசெய்த அனைத்தின் முழு நகல் வேண்டுமெனில் PDF receipt-ஐ download செய்யவும். திரையில் உள்ள பக்கத்தை print செய்ய வேண்டாம்.',
        ],
      },
      {
        heading: 'தொழிலாளர்கள் (ஏற்கனவே Home Leave / Urgent Leave-ல் இருந்தால்)',
        items: [
          'விடுப்பில் இருக்கும்போது passport-ஐ உங்களிடமே வைத்திருங்கள் — பெறுவதற்கான படி இல்லை.',
          'விடுப்பு முடிந்த பிறகு கேட்கப்படும்போது Passport Return திறக்கவும்.',
          'Original passport இன்னும் உங்களிடமே உள்ளது என்பதை உறுதிசெய்து, உங்கள் மொழியில் policy-ஐ acknowledge செய்யவும்.',
        ],
      },
      {
        heading: 'தொழிலாளர்கள் (passport-ஐ ஏற்கனவே எடுத்துச் சென்றிருந்தால்)',
        items: [
          'Renewal அல்லது தனிப்பட்ட காரணத்திற்காக HR ஏற்கனவே உங்கள் passport-ஐ வழங்கியிருந்தால், collection step இல்லை.',
          'Campaign தொடங்கிய பின் Passport Return-ஐ திறக்கவும்.',
          'Original passport இன்னும் உங்களிடமே உள்ளது என்பதை உறுதிசெய்து, உங்கள் மொழியில் policy-ஐ acknowledge செய்யவும்.',
        ],
      },
      {
        heading: 'HR administrators-க்கு',
        items: [
          'Inventory rule-ஐ உறுதிசெய்து, முழு worker roster-ஐ load செய்யவும் (held, on leave அல்லது already withdrawn).',
          'Launch-க்கு முன் English policy மற்றும் ஒவ்வொரு translation-க்கும் management/legal review பெறவும்.',
          'Held cohort: HR passport-களை வழங்கத் தயாரானதும் ஒருவரை அல்லது held passport அனைத்தையும் ready எனக் குறிக்கவும். ஒவ்வொருவருக்கும் collect செய்ய notification அனுப்பப்படும். Original document-ஐத் தொழிலாளரிடம் கொடுத்த பிறகே handover-ஐப் பதிவு செய்யவும்.',
          'On-leave cohort: விடுப்பு முடியும் வரை காத்திருக்கவும்; policy acknowledgement மட்டும் தேவையான record "Ack due" நிலைக்கு மாறும்.',
          'Already-withdrawn cohort: launch ஆனவுடன் policy acknowledgement தேவை—physical handover இல்லை.',
          'Already-withdrawn தொழிலாளர் campaign handover-க்கு முன் original passport-ஐ HR-க்கு மீண்டும் கொடுத்தால், "Passport now in the safe" பயன்படுத்தவும். Record Physical return-க்கு மாறும். அவருக்கு notification அனுப்பாதீர்கள்; passport HR-இடம் இருக்கும்போது acknowledge செய்யச் சொல்லாதீர்கள்.',
          'Acknowledged record-ல் "View acknowledgement receipt" மூலம் confirmations, acknowledgement நேரத்தில் உறையவைக்கப்பட்ட passport number/expiry, சரியான language snapshot, timestamp மற்றும் English reference translation-ஐப் பார்க்கவும். முழு multi-page copy-க்கு Download PDF பயன்படுத்தவும்; on-screen modal-ஐ print செய்ய வேண்டாம்.',
          'Handover அல்லது விடுப்பிலிருந்து திரும்பிய பின் portal acknowledgement பெற முடியாவிட்டால், இரண்டாவது HR administrator-ஐ witness ஆக வைத்து விரிவான exception-ஐப் பதிவு செய்யவும். Passport-ஐ மீண்டும் எடுத்துக்கொள்ள வேண்டாம்.',
          'ஒவ்வொரு action-உம் மாற்ற முடியாத campaign timeline மற்றும் central audit log-ல் சேமிக்கப்படும்.',
        ],
      },
    ],
  },

  events: {
    title: 'Meetings & Training Attendance',
    summary: 'நிகழ்வை நடத்தி, மாறிக்கொண்டிருக்கும் QR code மூலம் வருகையைப் பதிவு செய்யுங்கள்.',
    routeLabel: 'Events திறக்கவும்',
    blocks: [
      {
        text: 'Staff மற்றும் directors நிகழ்வை நடத்தலாம். Attendees (வெளிப்புற விருந்தினர்களும்) QR code-ஐ scan செய்தால் போதும் — சிறப்பு access தேவையில்லை.',
      },
      {
        heading: 'நிகழ்வை நடத்த',
        items: [
          'Self-Service → "Meetings & Training Attendance" → "New event" என்பதைத் தட்டவும்.',
          'Title, type (Meeting / Training / Briefing / Other), தேதி, நேரம் மற்றும் விருப்பப்பட்டால் project/location-ஐ உள்ளிடவும்.',
          '"Create event" என்பதைத் தட்டவும் (Draft ஆகத் தொடங்கும்); தயாரானதும் "Activate & show QR" என்பதைத் தட்டவும்.',
          'Phone அல்லது TV-ல் code-ஐக் காட்ட "Present QR" என்பதைத் தட்டவும் — பாதுகாப்புக்காக அது தானாக மாறும்.',
          'முடிந்ததும் check-in-ஐ நிறுத்தி attendance record-ஐ உங்களுக்கு email செய்ய "Close & email PDF" என்பதைத் தட்டவும். தவறவிட்டவருக்காக "Reopen for late check-ins" செய்யலாம்.',
        ],
      },
      {
        heading: 'நிகழ்வில் Check in செய்ய',
        items: [
          'உங்கள் phone camera மூலம் QR code-ஐ scan செய்யவும்.',
          'Employees: உறுதிசெய்ய sign in செய்யவும் — உங்கள் விவரங்கள் முன்நிரப்பப்படும்.',
          'External guests (அனுமதிக்கப்பட்டால்): "I\'m an external attendee" என்பதைத் தேர்ந்தெடுத்து விவரங்களை நிரப்பவும்.',
          'திரையில் கையொப்பமிட்டு (signature கட்டாயம்), "Check in" என்பதைத் தட்டவும்.',
        ],
      },
      {
        text: 'QR ஒவ்வொரு 20 விநாடிக்கும் புதுப்பிக்கும். பின்னர் பகிரப்படும் screenshot வேலை செய்யாது — நேரடியாக scan செய்யவும்.',
      },
    ],
  },

  whistleblowing: {
    title: 'பெயரில்லா தவறான நடத்தைப் புகார்',
    summary: 'தவறான நடத்தை, மோசடி அல்லது விதிமீறலை ரகசியமாகப் புகாரளியுங்கள்.',
    routeLabel: 'Misconduct Reporting திறக்கவும்',
    blocks: [
      {
        text: 'உங்கள் புகார் முழுமையாகப் பெயரில்லாதது. உங்கள் submission பற்றிய எதுவும் HR portal-ல் சேமிக்கப்படாது — அங்கீகரிக்கப்பட்ட third-party assessor-க்கு மட்டும் செல்லும். பெயரும் email-உம் விருப்பமானவை; தொடர்புகொள்ள விரும்பினால் மட்டும் சேர்க்கவும்.',
      },
      {
        heading: 'புகாரளிப்பது எப்படி',
        items: [
          'Self-Service → "Anonymous Misconduct Reporting" திறந்து, கவன அறிவிப்பைப் படித்து "Done" என்பதைத் தட்டவும்.',
          'Follow-up வேண்டுமெனில் மட்டும் விருப்பமாக பெயர்/email சேர்க்கவும்.',
          'கட்டாய விவரங்களை நிரப்பவும்: சம்பந்தப்பட்டவர், violation type, என்ன/எப்போது நடந்தது, நடந்த இடம், வேறு யாருக்குத் தெரியும், உங்களுக்கு எப்படித் தெரிந்தது.',
          'ஆதார ஆவணங்கள் இருந்தால் இணைக்கவும் (விருப்பமானது).',
          'தகவல் உண்மை என்ற certification-ஐ tick செய்து "Submit" என்பதைத் தட்டவும்.',
        ],
      },
      {
        text: 'Confirmation திரையில் reference code (எ.கா. WB-YYYYMMDD-XXXXXX) கிடைக்கும் — அதை எழுதிவைத்துக்கொள்ளவும். Portal-ல் புகாரை மீண்டும் தேட வழியில்லை.',
      },
    ],
  },

  'big-five': {
    title: 'Big Five Profile',
    summary: 'உங்கள் சொந்த முடிவுகளுடன் விருப்பமாகச் செய்யக்கூடிய, ரகசிய personality assessment.',
    routeLabel: 'Big Five Profile திறக்கவும்',
    blocks: [
      {
        text: 'Big Five முழுமையாக விருப்பமானது. உங்கள் பதில்கள் encrypted ஆகும். Career உரையாடல்களுக்கு HR, HOD, Deputy HOD மற்றும் Reporting Officer உங்கள் தனிப்பட்ட முடிவைப் பார்க்கலாம் — ஒவ்வொரு access-க்கும் காரணம் அவசியம்; அது உங்கள் access log-ல் பதிவாகும். Trade Leaders மற்றும் பிற managers-க்கு அந்தப் பொறுப்புகளில் ஒன்றும் இல்லையெனில் பார்க்க முடியாது.',
      },
      {
        heading: 'Assessment செய்வது',
        items: [
          'Self-Service → "Big Five Profile" திறந்து "Start the assessment" என்பதைத் தட்டவும்.',
          'Consent-ஐப் படித்து ஏற்றுக்கொண்டு "Agree & begin" என்பதைத் தட்டவும்.',
          '120 குறுகிய statements-க்கு 1–5 அளவில் பதிலளிக்கவும் (Very Inaccurate → Very Accurate). பதில்கள் தானாகச் சேமிக்கும் — எந்த device-லிருந்தும் நிறுத்தி மீண்டும் தொடரலாம்.',
          'கடைசிக் கேள்வியில் "Submit Big Five Profile" என்பதைத் தட்டி முடிவைப் பார்க்கவும்.',
        ],
      },
      {
        heading: 'உங்கள் முடிவுகளும் உங்கள் கட்டுப்பாடும்',
        items: [
          'ஐந்து traits-ல் (Openness, Conscientiousness, Extraversion, Agreeableness, Neuroticism) உங்கள் scores-ஐப் பார்க்கவும்; விருப்பப்பட்டால் உலகளாவிய நபர்கள் அல்லது colleagues உடன் ஒப்பிடலாம்.',
          'ஒவ்வொரு HR access-ஐயும் கொடுக்கப்பட்ட காரணத்தையும் பார்க்க "Who has viewed me" என்பதைத் தட்டவும்.',
          'எப்போது வேண்டுமானாலும் consent-ஐத் திரும்பப் பெற்று உங்கள் data-ஐ நிரந்தரமாக delete செய்யலாம்.',
          'பொதுவாக 12 மாதத்திற்கு ஒருமுறை மீண்டும் செய்யலாம்.',
        ],
      },
    ],
  },

  notifications: {
    title: 'அறிவிப்புகள் & விருப்பங்கள்',
    summary: 'புதுப்பிப்புகளைப் பெற்று, எப்படி அறிவிக்கப்பட வேண்டும் என்பதைத் தேர்ந்தெடுக்கவும்.',
    routeLabel: 'Notification Preferences திறக்கவும்',
    blocks: [
      {
        heading: 'புதுப்பிப்புகளைப் பெறுதல்',
        items: [
          'சமீபத்திய notifications-ஐ (leave decisions, reminders, asset transfers, payslips, announcements மற்றும் பல) பார்க்க மேல் வலதுபுறம் உள்ள 🔔 மணியைத் தட்டவும்.',
          'மணியில் சிவப்புப் புள்ளி இருந்தால், படிக்காத பதிவு உள்ளது.',
        ],
      },
      {
        heading: 'எப்படி அறிவிக்கப்பட வேண்டும் என்பதைத் தேர்ந்தெடுக்க',
        items: [
          '🔔 மணியைத் திறந்து, settings (gear) குறியைத் தட்டி "Notification Preferences" திறக்கவும்.',
          'Leave, Attendance, Documents, Payroll, Assets, Celebrations போன்ற category-களில் தொகுக்கப்பட்ட notification types grid தெரியும்.',
          'ஒவ்வொரு type-க்கும் delivery channels-ஐ on/off செய்யவும்: In-App, WhatsApp, Email, Google Chat.',
          'செயல்படுத்த "Save Changes"; தவிர்க்க "Cancel" என்பதைத் தட்டவும்.',
        ],
      },
      {
        heading: 'தெரிந்திருக்க வேண்டியவை',
        items: [
          'In-App notifications எப்போதும் on-ல் இருக்கும்; off செய்ய முடியாது.',
          'WhatsApp-க்கு profile-ல் சரியான phone number; Email-க்கு சரியான email address தேவை.',
          'Lock குறி இருந்தால் administrator அந்த channel-ஐ அமைத்துள்ளார்; இங்கே மாற்ற முடியாது.',
          '"Disabled by policy" என்றால் நிறுவனம் அந்த notification-ஐ அனைவருக்கும் off செய்துள்ளது.',
          'Birthday Wishes: பக்கத்தின் கீழே company-wide birthday email-லிருந்து விலகலாம்.',
        ],
      },
    ],
  },

  help: {
    title: 'மேலும் உதவி தேவையா?',
    summary: 'சிக்கல் இருந்தால் HR குழுவை அணுகுங்கள்.',
    blocks: [
      {
        heading: 'HR-ஐ அணுகும் முன்',
        items: [
          'பக்கத்தைப் புதுப்பிக்க திரையை கீழே இழுக்கவும் — பழைய தகவல் சிக்கலை இது அடிக்கடி சரிசெய்யும்.',
          'உங்கள் நடவடிக்கைக்காக ஏதும் காத்திருக்கிறதா என்று 🔔 notifications-ஐப் பார்க்கவும்.',
          'Home screen-லிருந்து app-ஐ மூடித் திறந்து, சமீபத்திய version பயன்படுத்துகிறீர்களா என்று உறுதிசெய்யவும்.',
        ],
      },
      {
        text: 'இன்னும் உதவி தேவையா? உங்கள் Staff ID மற்றும் குறுகிய விளக்கத்துடன் (screenshot உதவும்) HR குழுவுக்கு hrm@winner-e.sg என்ற முகவரியில் email அனுப்பவும்.',
      },
    ],
  },
};
